import { TRAFFIC_LEVELS, type TrafficLevel } from '../../content/trafficLevels';
import { el } from '../components/el';

/** "Traffic: Light · Normal · Busy" segmented control. */
export function createTrafficPicker(onPick: (level: TrafficLevel) => void): { root: HTMLElement; select: (level: TrafficLevel) => void } {
  const root = el('div', 'traffic-picker');
  root.append(el('span', 'route-picker-label', 'Traffic'));
  const buttons = new Map<TrafficLevel, HTMLButtonElement>();
  for (const level of TRAFFIC_LEVELS) {
    const button = el('button', 'segment', level.label);
    button.addEventListener('click', () => {
      select(level.id);
      onPick(level.id);
    });
    buttons.set(level.id, button);
    root.append(button);
  }
  const select = (level: TrafficLevel): void => buttons.forEach((b, id) => b.classList.toggle('active', id === level));
  return { root, select };
}
